import { useEffect, useState } from 'react';

import i18n from '../../locales/i18n';

import { MuiLocaleProvider } from './mui-locale-provider/mui-locale-provider';

/**
 * NOTE:
 * - We could review this approach to leverage <I18nextProvider /> but this require a major refactor of UP and all apps.
 * - but this would allow to pass the locale as prop here and avoid the use of i18n.on('languageChanged', setLocale);
 */
export const LocaleProvider = ({ children }: React.PropsWithChildren) => {
  const [locale, setLocale] = useState(i18n.language);

  useEffect(() => {
    i18n.on('languageChanged', setLocale);

    return () => {
      i18n.off('languageChanged', setLocale);
    };
  }, []);

  return <MuiLocaleProvider locale={locale}>{children}</MuiLocaleProvider>;
};
